// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgMicrosoftLogo = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#microsoft_logo_svg__a)">
      <path fill="#F25022" d="M7.579 0H0v7.579h7.579z" />
      <path fill="#00A4EF" d="M7.579 8.421H0v7.58h7.579z" />
      <path fill="#7FBA00" d="M16 0H8.423v7.579H16z" />
      <path fill="#FFB900" d="M16 8.421H8.423v7.58H16z" />
    </g>
    <defs>
      <clipPath id="microsoft_logo_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgMicrosoftLogo
